module.exports = __webpack_public_path__ + "img/specials-multislider-6040--mazda.e64322e3.jpeg";